module.exports = __webpack_public_path__ + "static/floralbath1-edf322f7f09d22177ac287eaa1f32319.png";